import travelPlanApi from '../api/travelPlanApi';
import travelPlans from '../models/travelPlans';
import { generateParamsTravelPlan, generateParams } from '../functions/utils';
import * as myStore from '../store/myStore';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';
import { ITravelPlanFull } from 'redhotpie-shared-lib/interfaces/ITravelPlan';

class TravelPlanService {
  getUserTravel(): Promise<IApiResponse> {
    return travelPlanApi
      .getUserTravel()
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: travelPlans.mappingTravelObjects(res.data.items),
            };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: travelPlanService/getUserTravel:', res);
        return { success: res.success, data: [], message: res.data.message };
      })
      .catch(e => {
        console.warn('ERROR: travelPlanService/getUserTravel:', e);
        return { success: false, data: [], message: 'ERROR: travelPlanService/getUserTravel' };
      });
  }

  postUserTravel(params: any): Promise<IApiResponse<ITravelPlanFull[]>> {
    const { filter } = myStore.getStore().getState().travelPlanReducer;
    const body = params ? generateParamsTravelPlan(params) : generateParamsTravelPlan(filter);
    return travelPlanApi
      .postUserTravel(body)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: travelPlans.mappingTravelDestination(res.data.items),
            };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: travelPlanService/postUserTravel:', res);
        return { success: res.success, data: [], message: res.data.message };
      })
      .catch(e => {
        console.warn('ERROR: travelPlanService/postUserTravel:', e);
        return { success: false, data: [], message: 'ERROR: travelPlanService/postUserTravel' };
      });
  }

  getMyTravelPlan(params: any): Promise<IApiResponse<ITravelPlanFull[]>> {
    const optionParams = params ? generateParams({ ...params, pageSize: 24 }) : null;
    return travelPlanApi
      .getMyTravelPlan(optionParams)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: travelPlans.mappingMyTravelObjects(res.data.items),
            };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: travelPlanService/getMyTravelPlan:', res);
        return { success: res.success, data: [], message: res.data.message };
      })
      .catch(e => {
        console.warn('ERROR: travelPlanService/getMyTravelPlan:', e);
        return { success: false, data: [], message: 'ERROR: travelPlanService/getMyTravelPlan' };
      });
  }

  postCreateTravelPlan(params: any): Promise<IApiResponse> {
    return travelPlanApi
      .postCreateTravelPlan(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: travelPlans.myTravelPlanMappingObject(res.data),
            };
          }
          return { success: res.success, data: null };
        }
        console.log('ERROR: travelPlanService/postCreateTravelPlan:', res);
        return { success: false, data: null, message: res.message };
      })
      .catch(e => {
        console.warn('ERROR: travelPlanService/postCreateTravelPlan:', e);
        return { success: false, data: null, message: 'ERROR: travelPlanService/postCreateTravelPlan' };
      });
  }

  patchUpdateTravelPlan(params: any): Promise<IApiResponse> {
    return travelPlanApi
      .patchUpdateTravelPlan(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: travelPlans.myTravelPlanMappingObject(res.data),
            };
          }
          return { success: res.success, data: null };
        }
        console.log('ERROR: travelPlanService/patchUpdateTravelPlan:', res);
        return { success: false, data: null, message: res.message };
      })
      .catch(e => {
        console.warn('ERROR: travelPlanService/patchUpdateTravelPlan:', e);
        return { success: false, data: null, message: 'ERROR: travelPlanService/patchUpdateTravelPlan' };
      });
  }

  patchDeleteTravelPlan(listId: string[] | number[]): Promise<IApiResponse> {
    return travelPlanApi
      .patchDeleteTravelPlan(listId)
      .then(res => {
        if (res.success) {
          return { success: true, data: null };
        }
        console.log('ERROR: travelPlanService/patchDeleteTravelPlan:', res);
        return { success: false, data: null, message: res.message };
      })
      .catch(e => {
        console.warn('ERROR: travelPlanService/patchDeleteTravelPlan:', e);
        return { success: false, data: null, message: 'ERROR: travelPlanService/patchDeleteTravelPlan' };
      });
  }
}

export default new TravelPlanService();
